import {Layout, Anchor, Typography} from 'antd';
import React, {useState} from 'react';
import appColors from '../../style/theme';
import UnoPD from './ProductDesignPages/UnoPD';
import DosPD from './ProductDesignPages/DosPD';
import TresPD from './ProductDesignPages/TresPD';
import CuatroPD from './ProductDesignPages/CuatroPD';
import CincoPD from './ProductDesignPages/CincoPD';
import SeisPD from './ProductDesignPages/SeisPD';
import ReferencesPD from './ProductDesignPages/ReferencesPD';


const {Link} = Anchor;
const {Sider, Content} = Layout;
const Text = Typography;


const handleClick = (e, link) => {
  e.preventDefault();
  console.log(link);
};

const EntrepreneurshipPD = () => {
  const [backI, setBackI] = useState('transparent');
  const [backII, setBackII] = useState('transparent');
  const [backIII, setBackIII] = useState('transparent');
  const [backIV, setBackIV] = useState('transparent');
  const [backV, setBackV] = useState('transparent');
  const [backVI, setBackVI] = useState('transparent');
  const [backVII, setBackVII] = useState('transparent');

  const ChangeAnchor = (key) => {
    console.log(key);
    if (key === '#1') {
      setBackI(appColors['ColorD']);
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV('transparent');
      setBackVI('transparent');
      setBackVII('transparent');
    } else if (key == '#2') {
      setBackI('transparent');
      setBackII(appColors['ColorD']);
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV('transparent');
      setBackVI('transparent');
      setBackVII('transparent');
    } else if (key == '#3') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII(appColors['ColorD']);
      setBackIV('transparent');
      setBackV('transparent');
      setBackVI('transparent');
      setBackVII('transparent');
    } else if (key == '#4') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV(appColors['ColorD']);
      setBackV('transparent');
      setBackVI('transparent');
      setBackVII('transparent');
    } else if (key == '#5') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV(appColors['ColorD']);
      setBackVI('transparent');
      setBackVII('transparent');
    } else if (key == '#6') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV('transparent');
      setBackVI(appColors['ColorD']);
      setBackVII('transparent');
    } else if (key == '#7') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV('transparent');
      setBackVII(appColors['ColorD']);
      setBackVI('transparent');
    }
  };
  return (
    <Layout style={{background: 'transparent'}}>
      <Sider style={{background: 'transparent'}}>
        <Anchor onClick={handleClick} offsetTop={75} onChange={ChangeAnchor} style={{background: 'transparent'}}>
          <Link href='#1' title={<Content className='ContentAnchor' style={{borderColor: backI}}><Text style={{color: appColors['ColorD'], fontSize: '2.5vh'}}>Current State</Text></Content>}/>
          <Link href='#2' title={<Content className='ContentAnchor' style={{borderColor: backII}}><Text style={{color: appColors['ColorD'], fontSize: '3vh'}}>Regulations</Text></Content>}/>
          <Link href='#3' title={<Content className='ContentAnchor' style={{borderColor: backIII}}><Text style={{color: appColors['ColorD'], fontSize: '1.8vh'}}>Intellectual Property</Text></Content>}/>
          <Link href='#4' title={<Content className='ContentAnchor' style={{borderColor: backIV}}><Text style={{color: appColors['ColorD'], fontSize: '3vh'}}>Clinical Trials</Text></Content>}/>
          <Link href='#5' title={<Content className='ContentAnchor' style={{borderColor: backV}}><Text style={{color: appColors['ColorD'], fontSize: '3vh'}}>M & D</Text></Content>}/>
          <Link href='#6' title={<Content className='ContentAnchor' style={{borderColor: backVI}}><Text style={{color: appColors['ColorD'], fontSize: '3vh'}}>Validation</Text></Content>}/>
          <Link href='#7' title={<Content className='ContentAnchor' style={{borderColor: backVII}}><Text style={{color: appColors['ColorD'], fontSize: '3vh'}}>References</Text></Content>}/>
        </Anchor>
        <p style={{color: appColors['ColorD'], pointerEvents: 'none', fontSize: '2vh', top: '75vh', left: '5vh', textAlign: 'center', position: 'sticky'}}> P &nbsp;&nbsp; &nbsp; D <br/> R &nbsp; &nbsp;&nbsp; E<br/>O &nbsp; &nbsp;&nbsp; S<br/>D &nbsp;&nbsp;&nbsp; &nbsp;I<br/>U &nbsp; &nbsp;&nbsp;G<br/>C &nbsp; &nbsp;&nbsp;&nbsp;N<br/>T  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
      </Sider>
      <Layout style={{margin: '1% 1% 0 1%', width: 'fit-content'}}>
        <Layout style={{background: appColors['ColorX'], height: '1px'}} />
        <Layout className='PurpBack' style={{background: appColors['ColorG']}}>
          <Layout style={{margin: '0 0 0 0', background: 'transparent'}}>
            <div id='1'>
              <UnoPD/>
            </div>
            <div id='2'>
              <DosPD/>
            </div>
            <div id='3'>
              <TresPD/>
            </div>
            <div id='4'>
              <CuatroPD/>
            </div>
            <div id='5'>
              <CincoPD/>
            </div>
            <div id='6'>
              <SeisPD/>
            </div>
            <div id='7'>
              <ReferencesPD/>
            </div>
          </Layout>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default EntrepreneurshipPD;
